import { autoConvertToLocalDates } from "@olmokit/core/helpers/date";
import "./index.scss";

/**
 * Component: When
 */
export default function When() {
  autoConvertToLocalDates();

  return {};
}

// auto init:
When();
